import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { GoToHomeLoader } from '@confluence/home-redirects/entry-points/GoToHome.ts';
import { SiteHomepageRedirectLoader } from '@confluence/home-redirects/entry-points/SiteHomepageRedirect.ts';

export const WikiRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => (
	<SiteHomepageRedirectLoader>
		<GoToHomeLoader />
	</SiteHomepageRedirectLoader>
);

WikiRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'wikiScreen' },
	},
	MainLayout: {
		navView: PRODUCT_HOME_ID,
	},
});
